module.exports = __webpack_public_path__ + "static/img/edgar-web.96c68899.webp";